import { Controller } from "@hotwired/stimulus"
import { debounce } from "throttle-debounce"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 500 }
  }

  connect() {
    this._debouncedSubmit = debounce(this.delayValue, () => this.submitForm())
  }

  save() {
    this._debouncedSubmit()
  }

  saveNow() {
    this._debouncedSubmit.cancel()
    this.submitForm()
  }

  disconnect() {
    this._debouncedSubmit.cancel()
  }

  submitForm() {
    const form = this.element
    fetch(form.action, {
      method: "POST",
      body: new FormData(form),
      headers: {
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
      }
    })
  }
}
